<section class="ui-chart" [attr.aria-label]="'shared.chart.aria.chart' | translate: { title: (title() | uiLabelTranslate) }">
  <header class="ui-chart__header">
    <h3 class="ui-chart__title">{{ title() | uiLabelTranslate }}</h3>
    <p class="ui-chart__summary">
      {{
        subtitle()
          ? (subtitle() | uiLabelTranslate)
          : (variant() === 'pie'
              ? ('shared.chart.totalSummary' | translate: { count: totalValue() })
              : ('shared.chart.pointsSummary' | translate: { count: series().length }))
      }}
    </p>
  </header>

  @switch (variant()) {
    @case ('line') {
      <div class="ui-chart__line">
        <svg viewBox="0 0 100 100" class="ui-chart__line-svg" aria-hidden="true">
          <path class="ui-chart__line-grid" d="M 8 18 H 92 M 8 43 H 92 M 8 68 H 92 M 8 92 H 92"></path>
          <path class="ui-chart__line-path" [attr.d]="linePath()"></path>
          @for (point of lineMarkers(); track point.label) {
            <circle
              class="ui-chart__line-point"
              [attr.cx]="point.x"
              [attr.cy]="point.y"
              r="2.6"
              [attr.fill]="point.color"
            ></circle>
          }
        </svg>

        <div class="ui-chart__line-labels" role="list" [attr.aria-label]="'shared.chart.aria.series' | translate: { title: (title() | uiLabelTranslate) }">
          @for (point of series(); track point.label) {
            <div class="ui-chart__line-label">
              <strong>{{ point.value }}</strong>
              <span>{{ point.label }}</span>
            </div>
          }
        </div>
      </div>
    }

    @case ('pie') {
      <div class="ui-chart__pie">
        <div class="ui-chart__pie-ring" [style.background]="pieGradient()">
          <div class="ui-chart__pie-center">
            <strong>{{ totalValue() }}</strong>
            <span>{{ 'shared.chart.totalLabel' | translate }}</span>
          </div>
        </div>

        <div class="ui-chart__legend" role="list" [attr.aria-label]="'shared.chart.aria.series' | translate: { title: (title() | uiLabelTranslate) }">
          @for (point of series(); track point.label; let index = $index) {
            <div class="ui-chart__legend-item">
              <span class="ui-chart__legend-swatch" [style.background]="pointColor(point, index)"></span>
              <div>
                <strong>{{ point.label }}</strong>
                <p>{{ point.value }} · {{ pointPercent(point) }}%</p>
              </div>
            </div>
          }
        </div>
      </div>
    }

    @default {
      <div class="ui-chart__bars" role="list" [attr.aria-label]="'shared.chart.aria.series' | translate: { title: (title() | uiLabelTranslate) }">
        @for (point of series(); track point.label; let index = $index) {
          <div class="ui-chart__bar-card">
            <span class="ui-chart__bar-value">{{ point.value }}</span>
            <div class="ui-chart__bar-column">
              <span
                class="ui-chart__bar"
                [style.height.%]="maxValue() > 0 ? (point.value / maxValue()) * 100 : 0"
                [style.background]="pointColor(point, index)"
                role="presentation"
                [attr.aria-label]="point.label + ': ' + point.value"
              ></span>
            </div>
            <span class="ui-chart__label">{{ point.label }}</span>
          </div>
        }
      </div>
    }
  }
</section>
